import template from "./dialog-config.html";
import css from "./dialog-config.css";
import Dialog from "dialog";
import sleep from "sleep";

class ConfigVisiferDODialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-visifermdo", ConfigVisiferDODialog);
  }
  constructor() {
    super();

    document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));

    this.onupdatedevices_handler({detail: application.devices});

    this.show();
  }
  onupdatedevices_handler(event) {
    var devices = event.detail;

    this.textboxDeviceID.value = devices.visifermdo.id;
    this.textboxDeviceStatus.value = devices.visifermdo.status;
    this.textboxValue.value = devices.visifermdo.value;
    this.textboxCalibrationStatus.value = devices.visifermdo.calibrationStatus;
    this.textboxInternalTemperature.value = devices.visifermdo.internalTemperature;
  }
  async buttonClearCalibration_click() {
    try {
      this.buttonClearCalibration.style.pointerEvents = "none";  
      this.buttonClearCalibration.icon.iconname = "view-refresh";
      await server.rcall("RM_visifermdo_clearCalibration");
      this.buttonClearCalibration.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonClearCalibration.icon.iconname = "process-stop";
      alert(e);
    } finally {
      await sleep(3000);
      this.buttonClearCalibration.icon.iconname = "dialog-ok";
      this.buttonClearCalibration.style.pointerEvents = "";          
    }		
  }
  async buttonCalibrateTo0_click() {
    try {
      this.buttonCalibrateTo0.style.pointerEvents = "none";
      this.buttonCalibrateTo0.icon.iconname = "view-refresh";
      await server.rcall("RM_visifermdo_calibrateTo0");
      this.buttonCalibrateTo0.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonCalibrateTo0.icon.iconname = "process-stop";
      alert(e);
    } finally {
      await sleep(3000);
      this.buttonCalibrateTo0.icon.iconname = "dialog-ok";
      this.buttonCalibrateTo0.style.pointerEvents = "";
    }
  }
  async buttonCalibrateTo21_click() {
    try {
      this.buttonCalibrateTo21.style.pointerEvents = "none";
      this.buttonCalibrateTo21.icon.iconname = "view-refresh";
      await server.rcall("RM_visifermdo_calibrateTo21");
      this.buttonCalibrateTo21.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonCalibrateTo21.icon.iconname = "process-stop";
      alert(e);
    } finally {
      await sleep(3000);
      this.buttonCalibrateTo21.icon.iconname = "dialog-ok";
      this.buttonCalibrateTo21.style.pointerEvents = "";
    }
  }    
  buttonClose_click() {
    this.close();
  }
  close() {
    super.close();
  }
}

ConfigVisiferDODialog.constructor();

export default ConfigVisiferDODialog;